import $ from 'jquery';

require('slick-carousel/slick/slick');

$('.su_carousel__slider').slick({
	autoplay: true,
	autoplaySpeed: 5000,
	speed: 2000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	variableWidth: true,
	centerMode: true,
	lazyLoad: 'progressive',
	appendArrows: '.su_carousel__navigation',
	prevArrow: '.su_carousel__navigation--prev',
	nextArrow: '.su_carousel__navigation--next',
});